import { IUpdateProfileDTO } from '@/models/profile.model';
import { ProfileFields, TProfileValues } from '../helpers';

class UpdateProfileDTO implements IUpdateProfileDTO {
  full_name?: string;
  profile_photo?: string | null;
  email?: string;

  constructor(values: Partial<TProfileValues>) {
    this.full_name = values[ProfileFields.FULL_NAME];
    this.profile_photo = values[ProfileFields.PHOTO];
    this.email = values[ProfileFields.EMAIL];
  }
}

export default UpdateProfileDTO;
